<div>
    <quill-editor
        [placeholder]="_placeholder"
        [(ngModel)]="_value"
        (ngModelChange)="_onChangeCallback(_value)"
        (onBlur)="_onTouchedCallback(_value)"
        [sanitize]="true"
        [required]="required"
        [styles]="{ minHeight: inputMinHeight, height: inputFixedHeight }"
        [modules]="_modules"
    >
    </quill-editor>
</div>
